export default "__VITE_ASSET__CQIroThK__"